module.exports = __webpack_public_path__ + "static/media/testo_roles_genero.249cdfb0.jpg";